import { render, staticRenderFns } from "./resourceCenterCard.vue?vue&type=template&id=39e91681&scoped=true"
import script from "./resourceCenterCard.vue?vue&type=script&lang=js"
export * from "./resourceCenterCard.vue?vue&type=script&lang=js"
import style0 from "./resourceCenterCard.vue?vue&type=style&index=0&id=39e91681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e91681",
  null
  
)

export default component.exports